import * as Yup from "yup";

export function initialValuesSix(scene) {
  return {
    ModSixAdditionalMaterials: scene?.ModSixAdditionalMaterials || [],
    ModSixFilesPdf: scene?.ModSixFilesPdf || [],
    ModSixRepository: scene?.ModSixRepository || null,
    ModSixFuentes: scene?.ModSixFuentes || "",
    ModSixFooter: scene?.ModSixFooter || null,
  };
}

// Validation Schema
export function validationSchemaSix() {
  return Yup.object({
    ModSixAdditionalMaterials: Yup.array().of(Yup.string()),
    ModSixFilesPdf: Yup.array().of(Yup.string()),
    ModSixFuentes: Yup.string().nullable(), // Permitir que sea null si es opcional
    ModSixRepository: Yup.string().nullable(), // Permitir que sea null si es opcional
    ModSixFooter: Yup.string().nullable(), // Permitir que sea null si es opcional
  });
}
